<template>
  <div :class="$style.component">
    <span v-if="image.artist.title" v-html="image.artist.title" />
    <span v-if="image.title" :class="$style.title" v-html="image.title" />
    <span v-if="publicationYear" v-html="publicationYear" />
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object
    }
  },
  computed: {
    publicationYear() {
      return this.image.publication_year_freetext
        ? this.image.publication_year_freetext
        : this.image.publication_year
    }
  }
}
</script>

<style lang="scss" module>
.component {
  position: fixed;
  z-index: 1;
  left: 0;
  bottom: 0;
  padding: var(--gutter);
  width: 100%;
  text-align: center;
  background-color: var(--white-alpha);
  pointer-events: none;

  > :not(:last-child) {
    &:after {
      content: ',';
      padding-right: 0.25em;
    }
  }
}

.title {
  @extend %ff-italic;
}
</style>
